import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { LoaderComponent } from './loader/loader.component';
import { MasterTabListComponent } from './master-tab-list/master-tab-list/master-tab-list.component';
import { MasterTabComponent } from './master-tab/master-tab/master-tab.component';
import { NotResultFoundComponent } from './not-result-found/not-result-found.component';
import { MyFilterPipe } from './shared/pipes/my-filter.pipe';
import { StatusModalComponent } from './order/status-modal/status-modal.component';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MaterialModule } from './material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule, MatDialogModule } from '@angular/material';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { RedeemStatusModalComponent } from './redeem-status-modal/redeem-status-modal.component';
import { ImageModuleComponent } from './image-module/image-module.component';
import { OrderDetailComponent } from './order/order-detail/order-detail.component';
import { AgmCoreModule } from '@agm/core';
import { DistributionDetailComponent } from './distribution/distribution-detail/distribution-detail.component';
import { RouterModule } from '@angular/router';
import { RedeemRequestDetailComponent } from './redeem/redeem-request-detail/redeem-request-detail.component';
import { InfluencerDetailComponent } from './Influencer/influencer-detail/influencer-detail.component';
import { BillingDetailComponent } from './billing-detail/billing-detail.component';
// import { SalesReturnListComponent } from './sales-return/sales-return-list/sales-return-list.component';
import { CouponCodeAddComponent } from './coupon/coupon-code-add/coupon-code-add.component';
import { CouponCodeDetailComponent } from './coupon/coupon-code-detail/coupon-code-detail.component';
import { NgxBarcodeModule } from 'ngx-barcode';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { GatepassAddComponent } from './company-dispatch/gatepass-add/gatepass-add.component';
import { SecondaryOrderDetailComponent } from './order/secondary-order-detail/secondary-order-detail.component';
import { DesignationComponent } from './user/designation/designation.component';
import { AddDistributionComponent } from './distribution/add-distribution/add-distribution.component';
import { BottomSheetComponent } from './bottom-sheet/bottom-sheet.component';
import { AddGrandMasterBoxComponent } from './company-dispatch/add-grand-master-box/add-grand-master-box.component';
import { ViewMasterBoxDispatchDetailComponent } from './company-dispatch/view-master-box-dispatch-detail/view-master-box-dispatch-detail.component';
import { DistPrimaryOrderAddComponent } from './distribution/dist-primary-order-add/dist-primary-order-add.component';
import { ZingchartAngularModule } from 'zingchart-angular';
import { ListExpenseComponent } from './expense/list-expense/list-expense.component';
import { ContractorMeetListComponent } from './contractor-meet/contractor-meet-list/contractor-meet-list.component';
import { DistributionListComponent } from './distribution/distribution-list/distribution-list.component';
import { InstallationAddComponent } from './installation/installation-add/installation-add.component';
import { SecondaryOrderAddComponent } from './order/secondary-order-add/secondary-order-add.component';
import { SecondaryOrderListComponent } from './order/secondary-order-list/secondary-order-list.component';
import { SiteDetailComponent } from './site/site-detail/site-detail.component';
import { FollowupDetailComponent } from './followup/followup-detail/followup-detail.component';
import { ChangeEnquiryStatusComponent } from './lead/change-enquiry-status/change-enquiry-status.component';
import { IncentiveViewComponentComponent } from './incentive-view-component/incentive-view-component.component';
import { DetailExpenseComponent } from './expense/detail-expense/detail-expense.component';
import { ExpenseModalComponent } from './expense/expense-modal/expense-modal.component';
import { ContractorMeetDetailComponent } from './contractor-meet/contractor-meet-detail/contractor-meet-detail.component';
import { InventoryDetailComponent } from './inventory/inventory-detail/inventory-detail.component';
import { InventoryTransactionModalComponent } from './inventory-transaction-modal/inventory-transaction-modal.component';
import { AdvanceAddGiftComponent } from './Influencer/advance-add-gift/advance-add-gift.component';
import { ProductDetailDataComponent } from './distribution/product-detail-data/product-detail-data.component';
import { ChangeStatusComponent } from './purchase/change-status/change-status.component';






@NgModule({
  declarations: [
    NotResultFoundComponent,
    LoaderComponent,
    AddDistributionComponent,
    MyFilterPipe,
    AdvanceAddGiftComponent,
    ProductDetailDataComponent,
    SiteDetailComponent,
    MasterTabComponent,
    MasterTabListComponent,
    StatusModalComponent,
    DesignationComponent,
    DetailExpenseComponent,
    ContractorMeetDetailComponent,
    RedeemStatusModalComponent,
    ImageModuleComponent,
    ExpenseModalComponent,
    DistributionDetailComponent,
    RedeemRequestDetailComponent,
    InfluencerDetailComponent,
    OrderDetailComponent,
    InventoryDetailComponent,
    SecondaryOrderDetailComponent,
    DistPrimaryOrderAddComponent,
    BillingDetailComponent,
    CouponCodeAddComponent,
    // SalesReturnListComponent,
    GatepassAddComponent,
    FollowupDetailComponent,
    InstallationAddComponent,
    CouponCodeDetailComponent,
    BottomSheetComponent,
    AddGrandMasterBoxComponent,
    ViewMasterBoxDispatchDetailComponent,
    ListExpenseComponent,
    ContractorMeetListComponent,
    DistributionListComponent,
    SecondaryOrderAddComponent,
    SecondaryOrderListComponent,
    IncentiveViewComponentComponent,
    ChangeEnquiryStatusComponent,
    InventoryTransactionModalComponent,
    ChangeStatusComponent
  ],
  imports: [
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAZ-kqYo3DslRI2VIuvP5GIK7OK-U9n3AQ'
      /* apiKey is required, unless you are a
      premium customer, in which case you can
      use clientId
      */
    }),
    CommonModule,
    FilterPipeModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NgMultiSelectDropDownModule,
    MaterialModule,
    AutocompleteLibModule,
    MatIconModule,
    MatDialogModule,
    NgxMatSelectSearchModule,
    NgxBarcodeModule,
    NgxQRCodeModule,
    ZingchartAngularModule,
  ],
  exports: [
    NotResultFoundComponent,
    LoaderComponent,
    MyFilterPipe,
    FilterPipeModule,
    MasterTabComponent,
    MasterTabListComponent,
    DistributionDetailComponent,
    InfluencerDetailComponent,
    OrderDetailComponent,
    ListExpenseComponent,
    ContractorMeetListComponent,
    DistributionListComponent,
    SecondaryOrderListComponent,
    InventoryTransactionModalComponent
  ],
  entryComponents: [StatusModalComponent, ChangeEnquiryStatusComponent, ViewMasterBoxDispatchDetailComponent, GatepassAddComponent, RedeemStatusModalComponent, ImageModuleComponent, ExpenseModalComponent, DesignationComponent, BottomSheetComponent, IncentiveViewComponentComponent,InventoryTransactionModalComponent,AdvanceAddGiftComponent,ProductDetailDataComponent,ChangeStatusComponent]

})
export class AppUtilityModule { }
